import { ServerErrorIcon } from '@/app/components/UI/Icons'
import Link from 'next/link'

export default function ServerError() {
  return (
    <section className="flex flex-col items-center justify-center w-full text-center">
      <ServerErrorIcon className="m-auto" />
      <h1 className="text-2xl font-semibold">Oops!, algo salio mal</h1>
      <p className="px-2 my-10 text-xs text-center">
        Lo sentimos, se ha producido un error inesperado. Nuestro equipo ha sido
        notificado y trabajará para solucionarlo lo antes posible.
      </p>
      <Link
        href="/"
        passHref
        className="bg-orange-primary dark:bg-orange-darkMode hover:opacity-80 max-w-xs px-4 py-1 my-3 overflow-hidden font-medium text-white border border-transparent rounded shadow"
      >
        Volver al inicio
      </Link>
    </section>
  )
}
